import type {
  BreakingEventsListParams,
  BreakingNewsCategoriesResponse,
  BreakingNewsEventsListResponse,
} from '@/types/breaking.types';
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

export const breakingApi = {
  /**
   * Fetch breaking news categories
   */
  getBreakingCategories: async (): Promise<BreakingNewsCategoriesResponse> => {
    const response = await axiosClient.get<BreakingNewsCategoriesResponse>(
      API_ENDPOINTS.MARKETS_DISCOVERY_CATEGORIES,
      {
        params: {
          type: 'breaking-news',
        },
      },
    );
    return response.data;
  },

  /**
   * Fetch breaking news events list
   */
  getBreakingEventsList: async (
    params: BreakingEventsListParams,
  ): Promise<BreakingNewsEventsListResponse> => {
    const queryParams: Record<string, string | number | boolean> = {
      limit: params.limit,
      offset: params.offset,
      order: params.order,
      ascending: params.ascending,
      window: params.window,
      type: params.type,
    };

    if (params.tag_id !== null) {
      queryParams.tag_id = params.tag_id;
    }

    const response = await axiosClient.get<BreakingNewsEventsListResponse>(
      API_ENDPOINTS.MARKETS_EVENTS_LIST,
      {
        params: queryParams,
      },
    );
    return response.data;
  },
};
